<div class="menu-user-info-container">
  <div>
    <button data-testid="menu-close-button" disableRipple mat-button (click)="onClose()">
      <mat-icon [svgIcon]="IconNames.ice_close" />
    </button>
    <span class="menu-header-right-content">
      <button data-testid="menu-change-theme-button" disableRipple mat-button (click)="onChangeTheme()">
        <mat-icon [svgIcon]="selectedTheme.name === themes[1].name ? IconNames.ice_moon_filled : IconNames.ice_moon" />
      </button>
      <button data-testid="menu-settings-button" disableRipple mat-button [matMenuTriggerFor]="menu">
        <mat-icon [svgIcon]="IconNames.ice_settings" />
      </button>
    </span>
  </div>
  <mat-menu #menu="matMenu" disableRipple xPosition="before">
    <div class="user-menu-content-container" (keydown.tab)="$event.stopPropagation()">
      <button
        aria-haspopup="dialog"
        data-testid="menu-button-change-dealer-button"
        mat-menu-item
        tabindex="0"
        (click)="openDialogService.openChangeDealerDialog(activeDealer, dealers)"
      >
        <mat-icon [svgIcon]="IconNames.ice_house" />
        <span class="list-item">Endre dealer</span>
      </button>
      <mat-divider />
      <button data-testid="user-logout-button" mat-menu-item tabindex="0" (click)="logoff()">
        <mat-icon [svgIcon]="IconNames.ice_log_out" />
        <span class="list-item">Logg ut</span>
      </button>
      <mat-divider />
      <app-version-check />
    </div>
  </mat-menu>
  <div>
    <div class="user-name">{{ user?.name }}</div>
    <div class="dealer-name">{{ activeDealer?.displayName }}</div>
  </div>
</div>
